import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material";
import { Router } from "@angular/router";
import * as moment from 'moment';
import { ModalAntifraudWarningComponent } from "../../../../shared/modal-antifraud-warning/modal-antifraud-warning.component";
import { SharedModalInfoComponent } from "../../../../shared/modal-info/modal-info.component";
import { Util } from "../../../../utils/util";
import { Transfer } from "../../../models/transfer";
import { TransferType } from "../../models/transferType.enum";

import { AntifraudeDataModel } from "../models/antifraude-data.model";
import { TransactionDialogData } from "../models/transaction-dialog-data";
import { TransactionResponseStatus } from "../models/transaction-response-status.enum";
import { TransactionScheduledReceiptModel } from "../models/transaction-scheduled-receipt.model";
import { TransactionReceiptModel, TransactionResponseModel } from "../models/trasanction-response.model";



@Injectable()
export class TransactionHandlerService {
    private dialogResumeData = new TransactionDialogData();
    private scheduleReceiptModel = new TransactionScheduledReceiptModel();
    private antiFraudeData = new AntifraudeDataModel();
		private receiptModel = new TransactionReceiptModel();
		private situation: TransactionResponseStatus;

    constructor(
        private dialog: MatDialog,
        private router: Router,
    ) { }

    processResult(result: TransactionResponseModel, transactionType: TransferType, transactionScheduledData: Transfer): boolean {
				this.situation = result.situacaoTransferencia;

        switch (result.situacaoTransferencia) {
            case TransactionResponseStatus.AGUARDANDO_AUTORIZACAO:
                this.setDialogScheduledTransactionData(transactionScheduledData);
                this.setScheduledReceiptModel(transactionScheduledData, transactionType, false);
                return true;
            case TransactionResponseStatus.AUTORIZADA_AGUARDANDO_EFETIVACAO:
                this.setDialogScheduledTransactionData(transactionScheduledData);
                this.setScheduledReceiptModel(transactionScheduledData, transactionType, true);
                return true;
            case TransactionResponseStatus.TRANSFERENCIA_REALIZADA:
                this.setReceiptModel(result, transactionType);
                return true;
            case TransactionResponseStatus.AGUARDANDO_CONFIRMACAO_IF_DESTINO:
                this.openModal(
                'Estamos processando essa transação',
                'Essa transação esta demorando um pouco mais que o normal',
                'Assim que ela for concluída, ele estará disponível no Extrato. Caso contrário, consulte o item no menu Transações',
                'Entendi'
                );
                return false;
            case TransactionResponseStatus.TRANSFERENCIA_REPROVADA:
                this.openModal('Transação não concluída', '', result.mensagem);
                return false;
            case TransactionResponseStatus.TRANSFERENCIA_EXPIRADA:
                this.openModal('Transação não concluída', '', result.mensagem);
                return false;
            case TransactionResponseStatus.ERRO_TRANSFERENCIA:
                this.openModal('Transação não concluída', '', result.mensagem);
                return false;
            case TransactionResponseStatus.REJEITADA_IF_DESTINO:
                this.openModal('Transação não concluída', '', result.mensagem);
                return false;
            case TransactionResponseStatus.CANCELADA_TESOURARIA:
                this.openModal('Transação não concluída', '', result.mensagem);
                return false;
            case TransactionResponseStatus.CANCELADA_CLIENTE:
                this.openModal('Transação não concluída', '', result.mensagem);
                return false;
            case TransactionResponseStatus.AGUARDANDO_ANALISE_ANTIFRAUDE:
                this.setAntifraudModel(transactionScheduledData);
                return true;
            case TransactionResponseStatus.CANCELADA_SUSPEITA_FRAUDE:
								this.dialog.open(ModalAntifraudWarningComponent, {
									data: []
								});
                return false;

            default:
                this.openModal(
                    'Ocorreu um erro',
                    'Por favor tente novamente mais tarde.',
										'',
										'Entendi',
                );
                return false;
        }
    }

    setAntifraudModel(transactionScheduledData: Transfer): void {
				this.antiFraudeData.name = transactionScheduledData.favoredName;
				this.antiFraudeData.value = transactionScheduledData.value;
				this.antiFraudeData.dateTransaction = transactionScheduledData.dateLabel;
        this.antiFraudeData.showAntifraude = true;
    }

    getAntifraudModel(): AntifraudeDataModel {
        return this.antiFraudeData;
    }

    openModal(
    title: string,
    topText: string,
    text: string,
    btnName = 'Fechar',
    btnBackName = ''
    ) {
        const dialogRef = this.dialog.open(SharedModalInfoComponent, {
                width: '100%',
                maxWidth: '420px',
        data: {
            title: title,
            topText: topText,
            text: text,
            btnName: btnName,
            btnBackName: btnBackName,
        },
        });

        dialogRef.afterClosed().subscribe((result) => {
            this.router.navigate([''], { skipLocationChange: true });
        });
    }

	setScheduledReceiptModel(scheduledData: Transfer, transactionType: TransferType, authorized: boolean) {
			this.receiptModel.autorizado = authorized;
			this.receiptModel.agendado = (scheduledData.dateLabel && scheduledData.dateLabel !== moment().locale('pt-BR').format('DD/MM/YYYY'))  ? true : false;
			this.receiptModel.nomeFavorecido = Util.camelCaseText(scheduledData.favoredName);
			this.receiptModel.cpfCnpjFavorecido = scheduledData.favoredCpfCnpj.toString().trim();
			this.receiptModel.codBancoDestino = scheduledData.bankCode;
			this.receiptModel.nomeBancoDestino = scheduledData.bankDesc && Util.camelCaseText(scheduledData.bankDesc);
			this.receiptModel.codAgenciaDestino = + scheduledData.destinationAgency;
			this.receiptModel.codContaDestino = scheduledData.destinationAccount.slice(0, scheduledData.destinationAccount.length - 1) + '-' + scheduledData.destinationAccount.slice(- 1);
			this.receiptModel.valor = scheduledData.value;
			this.receiptModel.dataContabil = scheduledData.dateLabel;
			this.receiptModel.dataEmissao =   moment(new Date()).locale('pt-BR').format();
			this.receiptModel.autenticacao = "";
			this.receiptModel.tipoTransacao = transactionType === TransferType.ENTRE_CONTAS ? 'TEF' : transactionType;
	}

    getScheduledReceiptModel() {
        return this.receiptModel;
    }

    setDialogScheduledTransactionData(scheduledData: Transfer) {
        this.dialogResumeData.scheduled = true;
        this.dialogResumeData.value = scheduledData.value;
        this.dialogResumeData.bankName = scheduledData.bankDesc && Util.camelCaseText(scheduledData.bankDesc);
        this.dialogResumeData.favoredName = scheduledData.favoredName;
        this.dialogResumeData.transactionType = scheduledData.transferType;
        this.dialogResumeData.description = 'Transferência agendada' + ' - ' + scheduledData.transferType;
        this.dialogResumeData.transactionDate = 'Para ' + moment(scheduledData.date).locale('pt-BR').format('dd/MM/yyyy HH:mm:ss');
    }

	setReceiptModel(result: TransactionResponseModel, transactionType: TransferType) {
			this.receiptModel.autorizado = true;
			this.receiptModel.nomeFavorecido = Util.camelCaseText(result.sucesso.transacao.nomeFavorecido);
			this.receiptModel.cpfCnpjFavorecido = result.sucesso.transacao.cPFCNPJFavorecido.toString().trim();
			this.receiptModel.codBancoDestino = result.sucesso.transacao.codBancoDestino;
			this.receiptModel.nomeBancoDestino = Util.camelCaseText(result.sucesso.transacao.nomeBancoDestino);
			this.receiptModel.codAgenciaDestino = result.sucesso.transacao.codAgenciaDestino;
			this.receiptModel.codContaDestino = result.sucesso.transacao.codContaDestino.slice(0, result.sucesso.transacao.codContaDestino.length - 1) + '-' + result.sucesso.transacao.codContaDestino.slice(- 1);
			this.receiptModel.valor = result.sucesso.transacao.valor;
			this.receiptModel.dataContabil = result.sucesso.dataContabil;
			this.receiptModel.dataEmissao = result.sucesso.transacao.dataEmissao;
			this.receiptModel.autenticacao = result.sucesso.transacao.autenticacao;
			this.receiptModel.tipoTransacao = transactionType === TransferType.ENTRE_CONTAS ? 'TEF' : transactionType;
		}

	getReceiptModel(): TransactionReceiptModel{
			return this.receiptModel;
		}


		setDialogResumeData(result: TransactionResponseModel, transactionType: TransferType) {
				this.dialogResumeData.scheduled = false;
				this.dialogResumeData.value = result.sucesso.valor;
				this.dialogResumeData.bankName =  Util.camelCaseText(result.sucesso.transacao.nomeBancoDestino);
				this.dialogResumeData.favoredName = result.sucesso.transacao.nomeFavorecido ? result.sucesso.transacao.nomeFavorecido : '';
				this.dialogResumeData.receiptId = result.sequencial;
				this.dialogResumeData.transactionType = transactionType;
				this.dialogResumeData.description = 'Transferência enviada' + ' - ' + transactionType;
				this.dialogResumeData.transactionDate = moment(result.sucesso.dataTransacao)
			.locale('pt-BR')
						.format('DD MMMM YYYY - HH:mm');
    }

    getDialogResumeData(): TransactionDialogData {
        return this.dialogResumeData;
    }

		get transferSituation(): TransactionResponseStatus{
			return this.situation;
		}

		clearTransferSituation(): void {
			this.situation = undefined;
	}

	clearReceiptModel(): void {
		this.receiptModel =  new TransactionReceiptModel();
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/transfers-other-banks/transfer-response/services/transaction-handler.service.ts